import {NgModule} from '@angular/core';
import {SharedModule} from '../../app-common/shared.module';
import {nativesRoutingComponents, NativesRoutingModule} from './natives-routing.module';
import {NativeListPostComponent} from './components/native-list-post/native-list-post.component';
import {NativesUrlResolverService} from './services/natives-url-resolver.service';
import {NativesPostUrlResolverService} from './services/natives-post-url-resolver.service';
import {SearchWidgetV2Module} from 'src/app/components/search-widget-v2/search-widget-v2.module';
import {AdcampaignService} from '../../services/adcampaign.service';
import {SharedCmsModule} from '../../app-common/shared-cms.module';
import {UiIconComponent} from '../../components/ui/ui-icon/ui-icon.component';
import {UiButtonComponent} from '../../components/ui/ui-button/ui-button.component';

@NgModule({
  declarations: [nativesRoutingComponents, NativeListPostComponent],
  imports: [
    SharedModule,
    NativesRoutingModule,
    SharedCmsModule,
    SearchWidgetV2Module,
    UiIconComponent,
    UiButtonComponent,
  ],
  providers: [NativesUrlResolverService, NativesPostUrlResolverService, AdcampaignService],
  exports: [],
})
export class NativesModule {}
